export enum Colors {
  PRIMARY = "primary",
  SECONDARY = "secondary",
  SUCCESS = "success",
  DANGER = "danger",
  WARNING = "warning",
  INFO = "info",
  LIGHT = "light",
  DARK = "dark",
  BLACK = "black",
  TRANSPARENT = 'transparent'
}

export enum FontFamily {
  MUNDIAL_LIGHT = 'mundialLight',
  MUNDIAL_REGULAR = "mundialRegular",
  MUNDIAL_SEMIBOLD = 'mundialSemibold',
  MUNDIAL_BOLD = 'mundialBold'
}

export enum BackgroundColors {
  TRANSPARENT = "transparent",
  PINK = "pink",
  WHITE = "white",
  GRAY = "gray",
  LIGHT_BLUE = "lightBlue",
  WITHOUT_BORDER = "withoutBorder",
  BLACK = "black",
  LIGHT_GRAY ="lightGray"
}

export enum QuantityMode {
  MINUS = 'minus',
  PLUS = 'plus',
  AUTO = 'auto'
}

export enum StaticPages {
  NEWS = 'news',
  PRODUCTS = 'products',
  CART = 'cart',
  // LOCATIONS = 'locations',
  PROFILE_INFO = 'profile_info',
  PROFILE_WISHLIST = 'profile_wishlist',
  PROFILE_ORDERS = 'profile_orders',
  PROFILE_SETTINGS = 'profile_settings',
  PROFILE_INTERESTS = 'profile_interests',
  PROFILE_ADDRESSES = 'profile_addresses',
  OUTLET = 'outlet'
}

export enum CustomerFormType {
  CUSTOMER = 'customer',
  COMPANY = 'company'
}